<template>
  <div class="containerNcmA">
       <b-modal id="idac" ref="idac" size="lg"  hide-footer >
          <p style="text-align:center">Indisponível</p>
      </b-modal>
      <div class="painel">
          <img src="https://www.lefisc.com.br/arqlef/arqlef2.svg" alt="">
      </div>      
      <div class="conteudoPrincipal">
        <br>
        <br>
        <img src="/arqlef/img/2892184.svg" alt="" class="logoarq">
        <p class="titulo">ARQLEF</p>
        <p class="texto" v-html="texto"></p>
        <br>
        <br>
        <a href="https://www.youtube.com/watch?v=tGWTkUmOB-Y"  target="_blank"> Tutorial </a> <br>
        <img src="/arqlef/img/v.png" alt="" @click="abrir()" style="cursor:pointer; width:300px;">
        <p class="titulo espacamento">Comece a usar o ARQLEF</p>
        <button class="btncadastrar" @click="conteudo">
            Acesse Agora
        </button>
        </div>
        <br>
        <br>
        <br>
  </div>
</template>

<script>

import config from '../services/config.js'
export default {
    data(){
        return{
            texto:''
        }
    },
    methods:{        
        abrir(){
            window.open('https://www.youtube.com/watch?v=tGWTkUmOB-Y','_blank')
        },
       conteudo(){
           if(this.$store.state.idCliente == '9475'){
               this.$refs['idac'].show()
           }else{
            this.$router.push({
                name:'empresas'
                })
           }
        },   
    },    
    async created(){
        
        document.documentElement.scrollTop = 0;
        let texto = await config.getTexto()
        console.log(this.texto)
        if(texto.status < 400){
            this.texto = texto.data
        }
    }
}
</script>

<style >
.containerNcmA{
    margin:0 auto;
    max-width: 1160px; 
    background: #fff;
    min-height: 100vh;
}
.painel{
    height: 25vw;
    background-image: url('https://www.lefisc.com.br/arqlef/img/2645928.jpg');
    background-color: #005E00;
    background-blend-mode: multiply;
    background-size: 100% 120%;
    background-repeat: no-repeat;
    background-blend-mode: multiply; 
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.painel img{
    width: 400px;
    margin-bottom:0px;
}
.painel .logoTi{
    font-size: 64px;
    font-weight: bold;
    color: #fff;
}
.conteudoPrincipal{
    max-width: 700px;
    margin:0px  auto;
}
.conteudoPrincipal .logoarq{
    margin-top:70px;
}
.conteudoPrincipal .titulo{
    color: #707070;
    font-size: 1.9em;
    font-weight: bold;
    margin-top:10px;
}   
.conteudoPrincipal .texto{
    color: #707070;
}
.conteudoPrincipal .espacamento{
    color: #707070;
    margin-top:50px;
}
.conteudoPrincipal .btncadastrar{
    width: 292px;
    height: 76px;
    border-radius: 10px;
    color:#fff;
    background: #009188;
    border:none;
    font-weight: 600;
}
.conteudoPrincipal .btncadastrar:focus{
    outline: none;
}
@media only screen and (max-width: 600px) {
  .painel{
    height: 23vh;
  }
  .painel .logoTi{
    font-size: 53px;
  }
  .conteudoPrincipal p.pSe{
    font-size: 25px;
  }
  .conteudoPrincipal .painelCard{
      justify-content: center;
  }
  .conteudoPrincipal .painelCard .caixa .bola[data-v-066a97fd] {
    width: 132px;
    height: 132px;
  }
  .titAu{   
    font-size: 77px;
  }
  hr[data-v-066a97fd] {
    margin-top: 30px;
     margin-left: 28px; 
     margin-right: 28px;
  }
}
</style>
